import { useToast } from "@/components/ui/use-toast";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

export interface PaymentDetails {
	location_id: string;
	access_token: string;
	process_type: string;
	type: string;
	storeCard: boolean;
	user_id: string;
	card_holder: string;
	currency_iso: string;
	country_iso: string;
	phone_number: string;
	guest_id: number;
	"include-street"?: number;
	"include-street2"?: number;
	"include-zip"?: number;
	"include-email"?: number;
	"include-country"?: number;
	"include-city"?: number;
	"include-state"?: number;
}

export type SubmitPaymentArgs = PaymentDetails;

export function useSubmitPayment(
	options?: MutationOptionsWithoutFn<unknown, PaymentDetails>,
) {
	const { toast } = useToast();
	return useMutation({
		mutationFn: async (paymentDetails: SubmitPaymentArgs) => {
			// @ts-ignore
			if (typeof window.submitPayment === "function") {
				// @ts-ignore
				return window.submitPayment(paymentDetails);
			}
			toast({
				title: "Payment Submission Failed",
				variant: "destructive",
			});
		},
		...options,
	});
}
